import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unixDate',
  pure: false,
})
export class UnixDatePipe implements PipeTransform {
  transform(value: number): string {
    if (!value) return 'N/A';
    return new Date(value * 1000).toLocaleString();
  }
}
